/**
 * Badge "Prezzi disallineati" visualizzato su un preventivo quando almeno una
 * stratigrafia ha materiali aggiornati dopo l'ultimo bulk update prezzi.
 * Mostra il count di righe e suggerisce di cliccare "Aggiorna prezzi".
 */
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { RefreshCw } from 'lucide-react';
import { useEstimateStaleStatus } from '@/hooks/useEstimateStaleStatus';

interface PriceStaleBadgeProps {
  estimateId: string;
  /** Variante compatta (solo icona + count) per liste densi. */
  compact?: boolean;
}

const PriceStaleBadge: React.FC<PriceStaleBadgeProps> = ({ estimateId, compact }) => {
  const status = useEstimateStaleStatus(estimateId);
  if (!status || !status.isStale) return null;

  if (compact) {
    return (
      <Badge
        variant="outline"
        className="bg-blue-50 text-blue-700 border-blue-200 gap-1 h-5 text-[10px]"
        title={`${status.staleRowsCount} righe con prezzi disallineati — clicca "Aggiorna prezzi" nel detail`}
      >
        <RefreshCw className="h-3 w-3" />
        {status.staleRowsCount}
      </Badge>
    );
  }

  return (
    <Badge
      variant="outline"
      className="bg-blue-50 text-blue-700 border-blue-200 gap-1.5"
      title="Prezzi materiali aggiornati dopo l'ultimo ricalcolo. Clicca 'Aggiorna prezzi' per riallineare."
    >
      <RefreshCw className="h-3.5 w-3.5" />
      {status.staleRowsCount} {status.staleRowsCount === 1 ? 'riga' : 'righe'} con prezzi disallineati
    </Badge>
  );
};

export default PriceStaleBadge;
